import { MenuItem as MuiMenuItem, MenuItemProps as MuiMenuItemProps, styled } from "@mui/material";

const StyledMenuItem = styled(MuiMenuItem)(() => {
  return {
    fontWeight: "500",
  };
});

interface MenuItemProps extends MuiMenuItemProps {
  children: React.ReactNode;
}

export const MenuItem: React.FC<MenuItemProps> = ({ children, ...props }) => {
  return <StyledMenuItem {...props}>{children}</StyledMenuItem>;
};

export default MenuItem;
